import { eHierarchyLevel } from "functions/api/enums";
import { HierarchyReadDto } from "functions/api/hierarchy/HierarchyReadDto";

/**
 * Resolves which hierarchy IDs should be queried for clinical library data.
 *
 * Study and report hierarchies only load the study-level clinical library.
 * All other hierarchy levels continue to load the current hierarchy together
 * with its linked parent hierarchies so inherited template data remains
 * available. The TopLevel hierarchy is excluded from the linked hierarchies
 * as it never holds clinical library data. When the hierarchy has not yet
 * loaded, no hierarchy IDs are returned.
 *
 * @param hierarchy - Current hierarchy loaded into context
 * @param hierarchyId - Current hierarchy identifier stored in state
 * @returns Ordered hierarchy IDs to pass to the batch clinical library API
 */
export const getClinicalLibraryHierarchyIds = (
  hierarchy: HierarchyReadDto | null,
  hierarchyId: string,
): string[] =>
  !hierarchy
    ? []
    : hierarchy.level === eHierarchyLevel.Study
      ? [hierarchy.id]
      : hierarchy.level === eHierarchyLevel.Report
        ? [
            hierarchy.hierarchyLinks.find((link) => link.hierarchyLevel === eHierarchyLevel.Study)
              ?.hierarchyId ?? hierarchy.id,
          ]
        : Array.from(
            new Set([
              hierarchyId,
              ...hierarchy.hierarchyLinks
                .filter((link) => link.hierarchyLevel !== eHierarchyLevel.TopLevel)
                .map((link) => link.hierarchyId),
            ]),
          );
